<template>
  <section id="dept-container" @click="search.show = false">
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="innerVisible"
    >
      <div id="d-search">
        <template>
          <div class="dept" @click.stop>
            <template v-for="(items, key) in chosen">
              <template v-for="(item, index) in items">
                <User
                  :item="item"
                  :key="index"
                  :type="key"
                  :showPhone="showPhone"
                  @removeTag="removeTag(key, item.id)"
                />
              </template>
            </template>
            <el-input
              v-if="
                this.model === 'user' ||
                  this.model === 'both' ||
                  this.model === 'bothAll'
              "
              v-model="search.keyword"
              placeholder="请输入关键字"
              @focus="search.show = true"
              class="h24"
            ></el-input>
            <div class="res" v-show="search.show && search.keyword">
              <div style="text-align:center;" v-show="search.loading">
                <i class="el-icon-loading fs16"></i>
              </div>
              <div
                style="text-align:center;font-size: 12px;"
                v-show="search['result'].length == 0 && !search.loading"
              >
                没有找到对应条件下人员
              </div>
              <template v-for="(item, index) in search['result']">
                <div class="item" :key="index">
                  <el-checkbox
                    v-model="item.checked"
                    @change="searchCheckedChange(item)"
                  >
                    <img
                      style="padding-left: 5px;"
                      class="tag-ava"
                      :src="item.icon || 'img/face.png'"
                      alt=""
                    />
                    <template v-if="showPhone"
                      >{{ item.name }}-{{ item.phone }}</template
                    >
                    <template v-else>{{ item.name }}</template>
                  </el-checkbox>
                </div>
              </template>
            </div>
          </div>
          <!-- end search -->
        </template>
      </div>
      <div id="d-menu" v-if="isSetOrgUrl">
        <el-tabs v-model="active">
          <el-tab-pane
            :label="choseName"
            name="org"
            v-if="
              model == 'user' ||
                model == 'org' ||
                model == 'both' ||
                model == 'bothAll' ||
                model == 'user_group' ||
                model == 'org_group'
            "
          >
            <Org
              ref="org"
              :max="max"
              :chosen.sync="chosen"
              :model="model"
              :showPhone="showPhone"
              :url="orgUrl"
              @orgChange="orgChange"
              @updateChosen="updateChosen"
            />
          </el-tab-pane>
          <!-- org -->
          <el-tab-pane
            label="角色"
            name="group"
            v-if="
              model == 'group' ||
                model == 'bothAll' ||
                model == 'user_group' ||
                model == 'org_group'
            "
          >
            <Group
              ref="group"
              :max="max"
              :url="orgUrl"
              :chosen.sync="chosen"
              :model="model"
              @updateChosen="updateChosen"
            />
          </el-tab-pane>
          <!-- group -->
        </el-tabs>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="innerVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
// import qs from "querystring";
import Group from "./group.vue";
import User from "./user.vue";
import Org from "./organization.vue";
import mixinOrgUrl from "@/components/qyDept/mixinOrgUrl.js";
// import url from "./this.url.js";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: 0
    },
    model: {
      type: String,
      default: "both" // org,group,user,both,bothAll,user_group,org_group
    },
    selected: {
      type: Object,
      default: function() {
        return {
          org: [],
          user: [],
          group: []
        };
      }
    },
    title: {
      type: String,
      default: "人员选择器"
    },
    choseName: {
      type: String,
      default: "部门"
    },
    showPhone: {
      type: Boolean,
      default: false
    },
    urlType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      orgUrl: {},
      isSetOrgUrl: false,
      innerVisible: false,
      active: "",
      search: {
        show: false,
        keyword: "",
        loading: false,
        result: []
      },
      chosen: {},
      count: 1
    };
  },
  components: {
    Group,
    Org,
    User
  },
  mixins: [mixinOrgUrl],
  methods: {
    remoteMethod() {
      this.search["result"] = [];
      this.search["loading"] = true;
      this.$common
        .http({
          url: this.orgUrl.getUserByDeptId,
          data: {
            department_id: "",
            offset: 0,
            limit: 999999,
            type: 2,
            name: this.search.keyword
          }
        })
        .then(res => {
          this.search["result"] = res.data.data.items.map(val => {
            if (typeof this.chosen.user != "object") {
              this.chosen.user = {};
            }
            val.checked =
              this.chosen.user[val.id] &&
              this.chosen.user[val.id].id === val.id;
            return val;
          });
          console.log(this.search["result"]);
          this.search["loading"] = false;
        });
    },
    orgChange(nodes) {
      this.chosen.org = nodes;
    },
    updateChosen(data) {
      this.chosen = data;
    },
    getChosenLength(data) {
      let count = 0;
      for (let key in data) {
        console.log(data[key]);
        count = count + Object.keys(data[key]).length;
      }
      return count;
    },
    searchCheckedChange(item) {
      if (item.checked) {
        this.chosen.user[item.id] = item;
      } else if (this.chosen.user[item.id]) {
        delete this.chosen.user[item.id];
      }
    },
    removeTag(key, id) {
      delete this.chosen[key][id];
      this.forceUpdate();
    },
    confirm() {
      let obj = {};
      let tmp = this.$common.deep(this.chosen);
      // console.log(tmp)
      let selectLeng = 0;
      for (let key in tmp) {
        obj[key] = [];
        for (let index in tmp[key]) {
          obj[key].push(tmp[key][index]);
          selectLeng++;
        }
      }
      if (this.max && selectLeng > Number(this.max)) {
        this.$common.error("只能选择" + this.max + "个选项!");
        return;
      }
      this.innerVisible = false;
      this.$emit("confirm", obj);
    },
    transferSelectedToObj() {
      for (let key in this.selected) {
        const selected = this.selected[key];
        this.chosen[key] = {};
        selected.map(val => {
          this.chosen[key][val.id] = val;
        });
      }
    },
    forceUpdate() {
      this.chosen = this.$common.deep(this.chosen);
    }
  },
  watch: {
    "search.keyword": function(val) {
      if (val) {
        this.remoteMethod();
      }
    },
    visible: function(val) {
      this.innerVisible = val;
    },
    innerVisible: function(val) {
      if (!val) {
        this.search.keyword = "";
        this.search.result = [];
      }
      this.$emit("updateVisible", val);
      this.forceUpdate();
    },
    selected: {
      handler() {
        this.transferSelectedToObj();
      },
      deep: true
    }
  },
  async created() {
    this.orgUrl = await this.mixinOrgUrlSet(this.urlType);
    this.isSetOrgUrl = true;
    if (
      this.model == "user" ||
      this.model == "org" ||
      this.model == "both" ||
      this.model == "bothAll" ||
      this.model == "user_group" ||
      this.model == "org_group"
    ) {
      this.active = "org";
    }
    if (
      this.model == "group" ||
      this.model == "user_group" ||
      this.model == "org_group"
    ) {
      if (this.active.length == 0) {
        this.active = "group";
      }
    }
    this.transferSelectedToObj();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.ava {
  position: relative;
  top: 5px;
}
.res {
  position: absolute;
  width: calc(100% - 100px);
  background: #fff;
  z-index: 9999;
  border: 1px solid #eee;
  padding: 15px;
  border-radius: 3px;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  .item {
    padding: 3px 0;
  }
}
</style>
<style lang="less">
#dept-container {
  .el-dialog__body {
    padding: 15px 20px;
    margin-bottom: 5px;
    border-bottom: 1px solid #eee;
    border-top: 1px solid #eee;
  }
  .tag-ava {
    position: relative;
    width: 18px;
    height: 18px;
    top: 4px;
    margin-left: -5px;
  }
  .el-tabs__nav > div[role="tab"] {
    padding: 0 25px;
  }
  .is-active {
    border-bottom: 2px solid;
  }
  .el-input__inner {
    border: 0;
  }
  .h24 input {
    height: 24px;
  }
}
.dept {
  border: 1px solid #dcdfe6;
  min-height: 30px;
  border-radius: 4px;
  cursor: pointer;
  padding: 5px;
  .el-tag {
    margin-right: 5px;
    margin-bottom: 5px;
  }
  .el-input {
    width: 50%;
  }
}
</style>
